<template>
    <div class="row">
        <div class="col-8">
            <input-group icon="far fa-hourglass">
                <input type="number" class="form-control" v-model="time" :disabled="!unit" />
            </input-group>
        </div>
        <div class="col-4">
            <input-group icon="far fa-clock">
                <v-select class='form-control'
                    v-if="options.length != 0"
                    v-model="unit"

                    :options="options"
                    :clearable="false"
                    close-on-select
                >
                    <div slot='no-options' />
                </v-select>
            </input-group>
        </div>
    </div>
</template>

<script>

import {timeUnit, toSeconds, fromSeconds} from '../../Util/time';

import InputGroup from './InputGroup.vue';
import VSelect from 'vue-select';

export default {
    name: 'time-period',
    components: {
        VSelect,
        InputGroup
    },
    created() {
        const vm = this;

        //Ensure our newValue contains the required properties, and is reactive
        vm.newValue = {};
        vm.$set(vm.newValue, 'unit', !!(vm.value && vm.value.unit) ? vm.value.unit : '');
        vm.$set(vm.newValue, 'seconds', !!(vm.value && vm.value.seconds) ? vm.value.seconds : 0);
    },
    computed: {
        options() {
            const keys = Object.keys(timeUnit);
            const options = [];

            keys.forEach((key) => {
                options.push({ label: key, value: timeUnit[key] })
            });
            
            return options.reverse();
        },
        time: {
            get: function() {
                return fromSeconds(this.newValue.seconds, this.newValue.unit);
            },
            set: function(value) {
                this.newValue.seconds = toSeconds(value, this.unit.value);
            }
        },
        unit: {
            get: function() {
                const vm = this;
                const option = vm.options.find((option) => option.value === vm.newValue.unit);
                
                return option;
            },
            set: function(unit) {
                this.newValue.unit = unit ? unit.value : null;
                
                //Ensure our number is rounded on switch to another unit
                if(this.newValue.unit){
                    this.time = Math.round(fromSeconds(this.newValue.seconds, this.newValue.unit));
                }
            }
        }
    },
    watch: {
        newValue: {
            handler: function(value) {
                this.$emit('input', value);
            },
            deep: true
        }
    },
    data() {
        return {
            newValue: {}
        }
    },
    props: {
        value: {
            type: Object,
            default: () => {
                return { };
            }
        }
    }
};
</script>

<style>

</style>